import { useState } from 'react';
import { useScrollAnimation } from '../../hooks/useScrollAnimation';

export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { ref: headerRef, isVisible: headerVisible } = useScrollAnimation();
  const { ref: faqListRef, isVisible: faqListVisible } = useScrollAnimation();

  const faqs = [
    {
      question: 'Hizmetlerinizden nasıl yararlanabilirim?',
      answer:
        'Ücretsiz deneme hesabı oluşturarak platformumuzu 14 gün boyunca tüm özellikleriyle kullanabilirsiniz. Hesap oluşturma işlemi yalnızca birkaç dakika sürer ve herhangi bir kredi kartı bilgisi gerektirmez.',
    },
    {
      question: 'Ödeme yöntemleriniz nelerdir?',
      answer:
        'Kredi kartı, banka havalesi ve SWIFT transferi ile ödeme kabul ediyoruz. Kurumsal müşterilerimiz için fatura bazlı ödeme seçeneği de mevcuttur. Tüm ödemeler güvenli ödeme altyapımız üzerinden gerçekleştirilir.',
    },
    {
      question: 'Teknik destek hizmeti sunuyor musunuz?',
      answer:
        'Evet, tüm planlarımızda 7/24 teknik destek sunuyoruz. Kurumsal planımızda size özel bir hesap yöneticisi ve öncelikli destek hattı da dahildir. Ortalama yanıt süremiz iş saatlerinde 30 dakika, mesai dışında ise 4 saattir.',
    },
    {
      question: 'Verilerim güvende mi?',
      answer:
        'Tüm veriler SSL/TLS ile şifrelenerek aktarılır ve AES-256 standardında depolanır. SOC 2 Type II sertifikamız bulunmakta olup GDPR ve KVKK uyumluluğunu tam olarak sağlıyoruz. Verileriniz asla üçüncü taraflarla paylaşılmaz.',
    },
    {
      question: 'Planımı istediğim zaman değiştirebilir miyim?',
      answer:
        'Evet, planınızı istediğiniz zaman yükseltebilir veya düşürebilirsiniz. Plan değişikliklerinde ücret farkı bir sonraki fatura döneminde orantılı olarak yansıtılır. Herhangi bir bağlayıcılık süresi yoktur.',
    },
    {
      question: 'Ücretsiz deneme süresi ne kadar?',
      answer:
        'Tüm yeni kayıtlar 14 günlük ücretsiz deneme süresinden yararlanır. Bu süre zarfında planın tüm özelliklerine sınırsız erişebilirsiniz. Deneme süresi sonunda ücretli plana geçmek istemezseniz hesabınız otomatik olarak devre dışı kalır.',
    },
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          .faq-answer {
            max-height: 0;
            overflow: hidden;
            transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
          }
          .faq-answer.open {
            max-height: 200px;
          }
          @media (max-width: 768px) {
            .mobile-faq-section {
              padding-top: 40px !important;
              padding-bottom: 40px !important;
            }
            .mobile-faq-container {
              padding-left: 20px !important;
              padding-right: 20px !important;
              padding-top: 0 !important;
              padding-bottom: 0 !important;
            }
            .mobile-faq-content {
              flex-direction: column !important;
              gap: 32px !important;
            }
            .mobile-faq-header {
              width: 100% !important;
              height: auto !important;
              position: static !important;
            }
            .mobile-faq-title {
              font-size: 24px !important;
              line-height: 32px !important;
              width: 100% !important;
              position: static !important;
            }
            .mobile-faq-subtitle {
              font-size: 14px !important;
              line-height: 20px !important;
              width: 100% !important;
              position: static !important;
              margin-top: 16px !important;
            }
            .mobile-faq-list {
              flex: none !important;
            }
            .faq-answer {
              max-height: 0;
              overflow: hidden;
              transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
            }
            .faq-answer.open {
              max-height: 200px;
            }
          }
          `,
        }}
      />
      <div className="w-full py-[40px] bg-slate-950 flex justify-center items-center mobile-faq-section">
        <div className="w-full max-w-[1200px] px-[60px] py-10 bg-slate-950 flex flex-col justify-start items-start gap-14 mobile-faq-container">
          <div className="w-full flex justify-start items-start gap-20 mobile-faq-content">
            <div
              ref={headerRef}
              className={`w-96 h-48 relative mobile-faq-header transition-all duration-700 ease-out ${
                headerVisible
                  ? 'opacity-100 transform translate-y-0'
                  : 'opacity-0 transform translate-y-8'
              }`}
            >
              <div
                className="w-80 h-28 left-0 top-[-1.10px] absolute justify-center text-5xl font-bold font-['Inter'] leading-[59.80px] mobile-faq-title"
                style={{ color: '#FAFAFA' }}
              >
                Sıkça Sorulan
                <br />
                Sorular
              </div>
              <div
                className="w-80 h-14 left-0 top-[143.18px] absolute justify-center text-base font-normal font-['Inter'] leading-7 mobile-faq-subtitle"
                style={{ color: '#7A8599' }}
              >
                Hizmetlerimiz hakkında merak ettiğiniz
                <br />
                soruların yanıtlarını burada bulabilirsiniz.
              </div>
            </div>
            <div
              ref={faqListRef}
              className={`flex-1 inline-flex flex-col justify-start items-start gap-4 mobile-faq-list transition-all duration-700 ease-out ${
                faqListVisible
                  ? 'opacity-100 transform translate-y-0'
                  : 'opacity-0 transform translate-y-8'
              }`}
            >
              {faqs.map((faq, index) => {
                const isOpen = openIndex === index;
                return (
                  <div
                    key={index}
                    className="self-stretch rounded-2xl outline outline-1 outline-offset-[-1px] flex flex-col justify-start items-start overflow-hidden transition-all duration-300"
                    style={{
                      backgroundColor: 'rgba(17, 24, 39, 0.6)',
                      outlineColor: '#374151',
                    }}
                  >
                    <button
                      className="self-stretch px-7 py-6 inline-flex justify-between items-center hover:bg-white/5 transition-colors w-full text-left"
                      onClick={() => toggleFAQ(index)}
                    >
                      <div className="pb-px inline-flex flex-col justify-start items-start">
                        <div
                          className="justify-center text-base font-medium font-['Inter']"
                          style={{ color: '#F3F4F6' }}
                        >
                          {faq.question}
                        </div>
                      </div>
                      <div className="size-8 pt-[3px] pb-1 flex justify-center items-center">
                        <div
                          className="text-center justify-center text-xl font-normal font-['Inter'] transition-transform duration-300"
                          style={{
                            color: '#76BCE8',
                            transform: isOpen
                              ? 'rotate(45deg)'
                              : 'rotate(0deg)',
                          }}
                        >
                          +
                        </div>
                      </div>
                    </button>
                    <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
                      <div className="self-stretch px-7 pb-6 border-t border-white/10">
                        <div
                          className="pt-4 text-sm font-normal font-['Inter'] leading-6"
                          style={{ color: 'rgba(255, 255, 255, 0.7)' }}
                        >
                          {faq.answer}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
